import {
    BusSVG,
    CartSVG,
    ChatSVG,
    DollarSVG,
    EmojiSVG,
    HeartSVG, LinkSVG, NewsSVG,
    TVSVG,
} from "../components/ui/icons";

export const ProjectList = [
    {
        icon: <HeartSVG color={"currentColor"} size={25}/>,
        title: "Treffit Suomi 24",
        subtitle: "",
        technologies: [
            {
                name: "Go"
            },
            {
                name: "Python"
            },
            {
                name: "TypeScript"
            },
            {
                name: "php"
            },
            {
                name: "ElasticSearch"
            },
            {
                name: "GraphQL"
            },
            {
                name: "Postgres"
            },
            {
                name: "Redis"
            },
            {
                name: "Docker"
            },
            {
                name: "Kubernetes"
            },
            {
                name: "Kafka"
            },
            {
                name: "Prometheus"
            },
            {
                name: "ELK Stack"
            },
            {
                name: "AWS EC2"
            },
            {
                name: "Amazon CloudFront"
            },
            {
                name: "Github Actions (CI/CD)"
            }
        ],
        description: "Finnish dating platform. Distributed system with: auth-service, matchmaking algorithm, real-time messaging, profile management, posts and many more.",
        imgUrl: "/img/projects/treffitsuomi.webp",
        videoUrl: "/videos/unknown.mp4",
        githubUrl: "NONE",
        websiteUrl: "https://treffit.suomi24.fi/profile/create",
    },
    {
        icon: <BusSVG color={"currentColor"} size={25}/>,
        title: "Duralga - (back-end part)",
        subtitle: "An SDK for Laravel",
        technologies: [
            {
                name: "Go"
            },
            {
                name: "C++"
            },
            {
                name: "OSRM"
            },
            {
                name: "Kafka"
            },
            {
                name: "Geocoding"
            },
            {
                name: "Postgres"
            },
            {
                name: "GraphQL"
            },
            {
                name: "Redis"
            },
            {
                name: "Tile Server"
            },
            {
                name: "Docker"
            },
            {
                name: "Kubernetes"
            },
            {
                name: "Linux - Ubuntu"
            },
            {
                name: "Mongo"
            },
            {
                name: "ElasticSearch"
            }
        ],
        description: "DURALGA is a public transit app. Developed distributed back-end services for routing, retrieving transit information, ticketing, real-time notifications for approaching vehicles, watchlist and Geospatial data processing.",
        imgUrl: "/img/projects/duralga.webp",
        videoUrl: "/videos/unknown.mp4",
        githubUrl: "NONE",
        websiteUrl: "https://apps.apple.com/us/app/duralga/id1607990462",
    },
    {
        icon: <CartSVG color={"currentColor"} size={25}/>,
        title: "Electronics e-commerce",
        subtitle: "",
        technologies: [
            {
                name: "Python - Flask"
            },
            {
                name: "MySQL"
            },
            {
                name: "GraphQL"
            },
            {
                name: "Redis"
            },
            {
                name: "ElasticSearch"
            },
            {
                name: "RabbitMQ"
            },
            {
                name: "Docker"
            },
            {
                name: "Nginx"
            },
            {
                name: "Ubuntu"
            },
            {
                name: "VueJS"
            },
            {
                name: "Tailwind"
            },
            {
                name: "JavaScript"
            },
        ],
        description: "Elektronika.com.tm is a monolith e-commerce platform for electronics and appliances. Features efficient product catalog management, secure payment integration, modular back-end architecture. ",
        imgUrl: "/img/projects/elektronika.tm.webp",
        videoUrl: "/videos/unknown.mp4",
        githubUrl: "NONE",
        websiteUrl: "https://elektronika.com.tm",
    },
    {
        icon: <TVSVG color={"currentColor"} size={25}/>,
        title: "TV streaming",
        subtitle: "",
        technologies: [
            {
                name: "Go"
            },
            {
                name: "Python"
            },
            {
                name: "Redis"
            },
            {
                name: "Postgres"
            },
            {
                name: "GraphQL"
            },
            {
                name: "ElasticSearch"
            },
            {
                name: "NextJS"
            },
            {
                name: "ReactJS"
            },
            {
                name: "TailwindCSS"
            },
            {
                name: "JavaScript"
            },
            {
                name: "Kafka"
            },
            {
                name: "Redis"
            },
            {
                name: "Docker"
            },
            {
                name: "Nginx"
            },
            {
                name: "Ubuntu"
            },
            {
                name: "Kubernetes"
            }
        ],
        description: "TurkmenTV.gov.tm is the official website for Turkmenistan's national television network, offering viewers access to live TV streams, program schedules, and news updates.",
        imgUrl: "/img/projects/turkmentv.webp",
        videoUrl: "/videos/unknown.mp4",
        githubUrl: "NONE",
        websiteUrl: "https://turkmentv.gov.tm",
    },
    {
        icon: <DollarSVG color={"currentColor"} size={25}/>,
        title: "Ashgabat city 3D map",
        subtitle: "",
        technologies: [
            {
                name: "ThreeJS"
            },
            {
                name: "Bootstrap"
            },
            {
                name: "JavaScript"
            },
            {
                name: "jQuery"
            },
            {
                name: "WebGL"
            },
        ],
        description: "The Ashgabat City 3D Map is a web-based application built using Three.js for rendering 3D models of the city. Objects are exported in GLTF format for efficient loading and display. The map supports dynamic camera controls and interaction, with optimized performance for real-time rendering.",
        subdescription: "",
        imgUrl: "/img/projects/ashgabatcity.webp",
        githubUrl: "NONE",
        websiteUrl: "https://ashgabatcity.gov.tm/3dmap/",
    },
    {
        icon: <NewsSVG color={"currentColor"} size={25}/>,
        title: "Streamly",
        technologies: [
            {
                name: "Go"
            },
            {
                name: "Docker"
            },
            {
                name: "GitHub"
            },
            {
                name: "NYTimes RSS"
            },
            {
                name: "BBC News RSS"
            },
        ],
        description: "A simple Go-based news aggregator that fetches and filters news articles from various sources, such as BBC and The New York Times, and outputs the results to a news.md file.",
        imgUrl: "/img/projects/news-aggregator.webp",
        githubUrl: "https://github.com/ilmedova/Streamly",
        websiteUrl: "NONE",
    },
    {
        icon: <LinkSVG color={"currentColor"} size={25}/>,
        title: "URL Shortener",
        subtitle: "",
        technologies: [
            {
                name: "Go"
            },
            {
                name: "Redis"
            },
            {
                name: "Postgres"
            },
            {
                name: "Docker"
            },
            {
                name: "GitHub"
            }
        ],
        description: "Microservice to shorten a long link",
        imgUrl: "/img/projects/url-shortener.avif",
        githubUrl: "https://github.com/ilmedova/stock_prices_alert",
        websiteUrl: "NONE",
    },
    {
        icon: <ChatSVG color={"currentColor"} size={25}/>,
        title: "Chattle",
        subtitle: "An SDK for Laravel",
        technologies: [
            {
                name: "Composer",
            },
            {
                name: "Laravel",
            },
            {
                name: "JavaScript",
            },
            {
                name: "Tailwind",
            },
        ],
        description: "Chattle is an SDK for instantly enabling customer support chat widget, with admin panel for chatting with users.",
        imgUrl: "/img/projects/chattle.webp",
        githubUrl: "https://github.com/ilmedova/chattle",
        websiteUrl: "https://packagist.org/packages/ilmedova/chattle",
    },
    {
        icon: <EmojiSVG color={"currentColor"} size={25}/>,
        title: "Expressions to emoji",
        subtitle: "",
        technologies: [
            {
                name: "Python"
            },
            {
                name: "Tensorflow"
            },
            {
                name: "Keras"
            },
            {
                name: "OpenCV"
            },
            {
                name: "Numpy"
            },
            {
                name: "Jupyter"
            },
        ],
        description: "Human facial expressions to emoji converting application (education experiment). This is an AI agent built with Tensorflow, Keras, OpenCV and Numpy.",
        imgUrl: "/img/projects/computer_vision_demo.webp",
        githubUrl: "https://github.com/ilmedova/ml-fun",
        websiteUrl: "NONE",
    },
    {
        icon: <DollarSVG color={"currentColor"} size={25}/>,
        title: "Stock price alert",
        subtitle: "",
        technologies: [
            {
                name: "Python"
            },
            {
                name: "Flask"
            },
            {
                name: "ReactJS"
            },
            {
                name: "TailwindCSS"
            },
            {
                name: "AWS EC2"
            },
            {
                name: "SQL Alchemy"
            },
            {
                name: "GitHub CI/CD"
            },
            {
                name: "Docker"
            },
        ],
        description: "This is a microservice for user auth and watchlist",
        imgUrl: "/img/projects/stocks.webp",
        githubUrl: "https://github.com/ilmedova/stock_prices_alert",
        websiteUrl: "NONE",
    },
];
